import type { QualificationPolicyType } from '@/Network/Types/Requests/QualificationPolicyRequests'
export type { QualificationPolicyType }

export type ImportStep = 'form' | 'file' | 'result'

export interface ImportFormData {
  company: number | null
  healthUnit: number | null
  schedules: number[]
}

export const DEFAULT_POLICY_TYPE: QualificationPolicyType = 'TRANSFER_QUALIFICATION'
